import React from 'react'
import ModalFormUI from '../../../../widgets/form/ModalFormUI'
import InputDateUI from '../../../../widgets/form/InputDateUI'
import InputTextSF from '../../../../widgets/form/InputTextSF'
import InputSelectSF from '../../../../widgets/form/InputSelectSF'

const RepaymentChargeAmountModalUI = ({
  context, successMsg, errorList, setErrorList,
  updateMode, submitted,
  onSubmit, onCancelClick,
  // dueDate, onDueDateChange, dueDateError, setDueDateError,
  chargeAmount, onChargeAmountChange, chargeAmountError, setChargeAmountError,
  chargeRemarks, onChargeRemarksChange, chargeRemarksError, setChargeRemarksError,
  chargeStartDate,onChargeStartDateChange,chargeStartDateError,setChargeStartDateError,
  chargeEndDate,onChargeEndDateChange,chargeEndDateError,setChargeEndDateError,
  chargeType, onChargeTypeChange, chargeTypeError, setChargeTypeError, chargeTypeList,
}) => (
  <ModalFormUI
    context={context}
    titleLabel='Add Charges'
    buttonLabel='Save'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputSelectSF name='chargeType' label='Charge type'
      optionList={chargeTypeList} value={chargeType}
      onChange={onChargeTypeChange} error={chargeTypeError}
      setError={setChargeTypeError}
    />
    {/* <InputDateUI context={context} name='dueDate' label='Due date'
      selectedDateISO={dueDate} onChange={onDueDateChange}
      error={dueDateError} setError={setDueDateError}
    /> */}
    <InputTextSF type='text' name='chargeAmount' label='Charge amount'
      value={chargeAmount} onChange={onChargeAmountChange}
      error={chargeAmountError} setError={setChargeAmountError}
    />
    <InputTextSF type='text' name='chargeRemarks' label='Remarks'
      value={chargeRemarks} onChange={onChargeRemarksChange}
      error={chargeRemarksError} setError={setChargeRemarksError}
    />
    <InputDateUI context={context} name='chargeStartDate' label='Start Date'
      selectedDateISO={chargeStartDate} onChange={onChargeStartDateChange}
      error={chargeStartDateError} setError={setChargeStartDateError}
    />
    <InputDateUI context={context} name='chargeEndDate' label='End Date'
      selectedDateISO={chargeEndDate} onChange={onChargeEndDateChange}
      error={chargeEndDateError} setError={setChargeEndDateError}
    />    
  </ModalFormUI>
)

export default RepaymentChargeAmountModalUI
